<template>
  <AppMaintenance v-if="isAppDisabled" />
  <SessionBlocked v-else-if="isSessionBlocked" />
  <router-view v-else />
  <DevSidebar />
</template>

<script>
import Utils from "@/utils/Utils";
import DevSidebar from "@/components/DevSidebar";
import AppMaintenance from "@/components/AppMaintenance";
import SessionBlocked from "@/components/SessionBlocked.vue";

export default {
  name: "App",
  components: {
    DevSidebar,
    AppMaintenance,
    SessionBlocked,
  },
  data() {
    return {
      isAppDisabled: import.meta.env.VITE_APP_DISABLED == "true",
    };
  },
  computed: {
    isSessionBlocked() {
      return this.$store.state.sessions.sessionBlocked;
    },
  },
  mounted() {
    this.$store.state.users.$t = (value) => this.$t(value);
    this.$store.state.users.getLocale = () => this.$i18n.locale;
    this.$store.state.teachers.$t = (value) => this.$t(value);
    this.$store.state.students.$t = (value) => this.$t(value);
    this.$store.state.students.getLocale = () => this.$i18n.locale;
    this.$store.state.exercises.$t = (value) => this.$t(value);
    this.$store.state.blog.$t = (value) => this.$t(value);
    this.$store.state.classes.$t = (value) => this.$t(value);
    this.$store.state.homeworks.$t = (value) => this.$t(value);
    this.$store.state.schools.$t = (value) => this.$t(value);
    this.$store.state.countries.$t = (value) => this.$t(value);
    this.$store.state.administration.$t = (value) => this.$t(value);
    this.$store.state.bugsTracker.$t = (value) => this.$t(value);
    this.$store.state.garSubcriptions.$t = (value) => this.$t(value);
    this.$store.state.resources.$t = (value) => this.$t(value);
    this.$store.state.subscriptions.$t = (value) => this.$t(value);
    this.$store.state.mockExamTemplates.$t = (value) => this.$t(value);
    this.$store.state.sessions.$t = (value) => this.$t(value);
    this.$store.state.globalParameters.$t = (value) => this.$t(value);
  },
  watch: {
    $route: {
      handler(to) {
        if ("locale" in to.query) {
          if (
            localStorage.getItem("iizenglish-access-token") === null &&
            this.$store.getters["locales/getAvailableLocales"].includes(
              to.query.locale,
            )
          ) {
            // Set locale and cookie
            this.$i18n.locale = to.query.locale;
            Utils.setCookie("user-language", to.query.locale, 36521);
          }

          // Delete locale from url
          let query_params = { ...to.query };
          delete query_params.locale;
          this.$router.push({
            path: to.path,
            query: query_params,
            replace: true,
          });
        }
        if ("sso-token" in to.query) {
          // send request to api to login
          let ssoToken = to.query["sso-token"];
          this.$store
            .dispatch("users/ssoToken", ssoToken)
            .then((response) => {
              if (response && response.redirectTo) {
                this.$router.push({ name: "TwoFactorAuthentication" });
              } else {
                localStorage.setItem("display-subscribe-popup", true);

                if (this.$store.getters["users/getLanguageUsed"]) {
                  this.$i18n.locale =
                    this.$store.getters["users/getLanguageUsed"];
                  Utils.setCookie("user-language", this.$i18n.locale, 36521);
                }

                this.$router.push({ name: "PersonalHome" });
              }
            })
            .catch((error) => {
              if (error.response.status == 410) {
                this.$store.dispatch(
                  "notifications/addError",
                  {
                    message: this.$t(`message.notifications.linkExpired`),
                  },
                  { root: true },
                );
              } else {
                this.$store.dispatch(
                  "notifications/addError",
                  {
                    message: this.$t(`message.notifications.loginError`),
                  },
                  { root: true },
                );
              }
            });

          // Delete sso-token from url
          let query_params = { ...to.query };
          delete query_params["sso-token"];
          this.$router.push({
            path: to.path,
            query: query_params,
            replace: true,
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Gravity";
  src: url(./fonts/Gravity/Gravity-Regular.otf) format("OpenType");
}
@font-face {
  font-family: "Averia Sans Libre";
  src: url(./fonts/Averia_Sans_Libre/AveriaSansLibre-Regular.ttf)
    format("TrueType");
}
@font-face {
  font-family: "Digital 7";
  src: url(./fonts/Digital_7/digital-7.ttf) format("TrueType");
}

#app {
  font-family: "Gravity", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $baseColor;

  #toast-wrapper {
    position: relative;
    z-index: 1000;

    #toast-container {
      position: fixed;
      top: 0;
      right: 0;
      padding: 1rem;
    }
  }

  #instance-name {
    .container__ribon {
      /* Position */
      left: -64px;
      position: fixed;
      top: 32px;

      /* Size */
      height: 36px;
      width: 206px;

      font-size: 1.5rem;

      /* Displayed diagonally */
      transform: rotate(-45deg);

      /* Background color */
      background-color: $onDangerColor;

      opacity: 0.8;

      color: $whiteColor;

      /* Centerize the text content */
      text-align: center;

      z-index: 10;
    }
  }
  .mock-div {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
    background-color: transparent;
    font-size: 1rem;
  }

  .instructions-underlined {
    text-decoration: underline;
  }

  .instructions-italic {
    font-style: italic;
  }
}
</style>
